import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddSubjectMobile,
  successaddSubjectMobile,
} from "./AddSubjectMobileSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { ISubjectMobile } from "../../../Pages/SubjectMobile/ISubjectMobile";

import {
  failuredeleteSubjectMobile,
  successdeleteSubjectMobile,
} from "./DeleteSubjectMobileSlice";
import {
  failurelistSubjectMobile,
  successlistSubjectMobile,
} from "./ListSubjectMobileSlice";
import {
  failureEditSubjectMobile,
  successEditSubjectMobile,
} from "./EditSubjectMobileSlice";

// list
const ListSubjectMobileApi = () => {
  return api.get("/api/formula/subject/get");
};

export function* ListSubjectMobileCall() {
  try {
    const response: AxiosResponse = yield call(ListSubjectMobileApi);
    yield put(successlistSubjectMobile(response.data));
  } catch (error) {
    yield put(failurelistSubjectMobile(error));
  }
}

// add
const AddSubjectMobileApi = (action: PayloadAction<ISubjectMobile>) => {
  const formData = new FormData();

  if (action.payload.image_url) {
    formData.append("image_url", action.payload.image_url);
  }

  if (action.payload.year_levels) {
    // If year_levels is an array or object, stringify it
    formData.append("year_levels", JSON.stringify(action.payload.year_levels));
  }

  return api.post("/api/formula/subject/create", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      name: action.payload.name,
      sequence: action.payload.sequence,
      status: action.payload.status,
    },
  });
};

export function* AddSubjectMobileCall(action: PayloadAction<ISubjectMobile>) {
  try {
    const response: AxiosResponse = yield call(AddSubjectMobileApi, action);
    yield put(successaddSubjectMobile(response.data));
  } catch (error) {
    yield put(failureaddSubjectMobile(error));
  }
}

// edit
const EditSubjectMobileApi = (action: PayloadAction<ISubjectMobile>) => {
  const formData = new FormData();

  if (action.payload.image_url) {
    formData.append("image_url", action.payload.image_url);
  }

  if (action.payload.year_levels) {
    // If year_levels is an array or object, stringify it
    formData.append("year_levels", JSON.stringify(action.payload.year_levels));
  }

  return api.put("/api/formula/subject/update", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      id: action.payload.id,
      name: action.payload.name,
      sequence: action.payload.sequence,
      status: action.payload.status,
    },
  });
};

export function* EditSubjectMobileCall(action: PayloadAction<ISubjectMobile>) {
  try {
    const response: AxiosResponse = yield call(EditSubjectMobileApi, action);
    yield put(successEditSubjectMobile(response.data));
  } catch (error) {
    yield put(failureEditSubjectMobile(error));
  }
}

// delete
const DeleteSubjectMobileApi = (action: PayloadAction<number>) => {
  return api.delete("/api/formula/subject/delete", {
    params: { id: action.payload },
  });
};

export function* DeleteSubjectMobileCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSubjectMobileApi, action);
    yield put(successdeleteSubjectMobile(response.data));
  } catch (error) {
    yield put(failuredeleteSubjectMobile(error));
  }
}
